import React, { useState } from 'react';
import { db } from '../firebase'; // Adjust path if needed
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import './AdminPages.css'; // We'll use a shared CSS file

const CreateHub = () => {
    const [hubName, setHubName] = useState('');
    const [location, setLocation] = useState('');
    const [loading, setLoading] = useState(false);

    const handleCreateHub = async (e) => {
        e.preventDefault();
        if (!hubName.trim() || !location.trim()) {
            alert('Hub Name and Location cannot be empty.');
            return;
        }

        setLoading(true);
        try {
            await addDoc(collection(db, 'hubs'), {
                hubName: hubName,
                location: location,
                createdAt: Timestamp.now(),
            });
            alert(`Hub "${hubName}" created successfully!`);
            setHubName('');
            setLocation('');
        } catch (error) {
            console.error('Error creating hub: ', error);
            alert('Failed to create hub. Please check the console for errors.');
        }
        setLoading(false);
    };

    return (
        <div className="admin-page-container">
            <h1>Create a New Delivery Hub</h1>
            <div className="card">
                <form onSubmit={handleCreateHub} className="form-layout">
                    <div className="form-group">
                        <label htmlFor="hubName">Hub Name</label>
                        <input
                            id="hubName"
                            type="text"
                            value={hubName}
                            onChange={(e) => setHubName(e.target.value)}
                            placeholder="e.g., Downtown Center"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="location">Location / Address</label>
                        <input
                            id="location"
                            type="text"
                            value={location}
                            onChange={(e) => setLocation(e.target.value)}
                            placeholder="e.g., 123 Main St, Anytown"
                            required
                        />
                    </div>
                    <button type="submit" className="submit-button" disabled={loading}>
                        {loading ? 'Creating...' : 'Create Hub'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default CreateHub;